"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContactNameHash = exports.isContact = exports.getContactPhoneNumber = void 0;
var Web3Utils = __importStar(require("web3-utils"));
// Exports moved to @celo/base, forwarding them
// here for backwards compatibility
var contacts_1 = require("@celo/base/lib/contacts");
Object.defineProperty(exports, "getContactPhoneNumber", { enumerable: true, get: function () { return contacts_1.getContactPhoneNumber; } });
Object.defineProperty(exports, "isContact", { enumerable: true, get: function () { return contacts_1.isContact; } });
var getContactNameHash = function (contact) {
    if (!contact) {
        throw new Error('Invalid contact');
    }
    return Web3Utils.keccak256(contact.displayName || '');
};
exports.getContactNameHash = getContactNameHash;
//# sourceMappingURL=contacts.js.map